import { ReactComponent as ProductOtherIcon } from "@/assets/images/product-other.svg";
import { ReactComponent as ProductOwnIcon } from "@/assets/images/product-own.svg";
import { ProjectType } from "@/consts/Bid";
import { ProjectType as ParsedProjectType } from "@/consts/Project";
import { SpecReadReagentsResponse } from "@/types/specs";
import { Check, X } from "lucide-react";
import { ReagentsSchema } from "../components/ChemicalSpecs";

export const getIcon = (
  isOwnProduct: boolean,
  hasAlternativeProducts: boolean
) => {
  if (isOwnProduct) {
    return <ProductOwnIcon />;
  } else {
    return <ProductOtherIcon />;
  }
};

export const parsePrice = (
  price: number | string | null | undefined
): number => {
  const parsed = Number(price);
  return isNaN(parsed) || !isFinite(parsed) ? 0 : Math.round(parsed);
};

export const getPrice = (price: number | string) => {
  if (!price) {
    return "-";
  }

  return parsePrice(price).toLocaleString() + "원";
};

export const getMatchIcon = (matchScore: number, maxScore: number) => {
  const percentage = (matchScore / maxScore) * 100;
  if (percentage === 100) {
    return <Check size={16} className="text-green" />;
  } else if (percentage >= 80) {
    return <span className="text-yellow-500">⚠</span>;
  } else {
    return <X size={16} className="text-red-500" />;
  }
};

export const getStatusIcon = (isMatch: boolean) => {
  return isMatch ? (
    <Check size={24} className="text-green shrink-0" />
  ) : (
    <X size={24} className="text-pink shrink-0" />
  );
};

export const convertToFormValues = (
  data?: SpecReadReagentsResponse
): ReagentsSchema => {
  if (!data) {
    return { reagents: [] };
  }

  const reagents = data.reagents
    .filter((r) => r.alt_items.length > 0)
    .map((r) => ({
      spec_id: r.spec_id,
      alt_items: r.alt_items.map((item) => ({
        alt_map_id: item.alt_map_id,
        selected: item.selected,
      })),
    }));

  return { reagents };
};

export const parseProjectType = (projectType?: string): ParsedProjectType => {
  switch (projectType) {
    case ProjectType.Original:
      return ParsedProjectType.PROJ;
    case ProjectType.Procure:
      return ParsedProjectType.PRCR;
    case ProjectType.BidPlan:
      return ParsedProjectType.PLAN;

    default:
      return ParsedProjectType.PROJ;
  }
};
